const ROOT = '';

const routes = {
  root: ROOT,
  grid: ROOT + '/grid',
};

export default routes;
